import api from '../token';

export const DeleteFormaPagamento = async (dados) => {
  try {
    const response = await api.post('/deleteFormaPagamento', dados);
    return response.data;
  } catch (error) {
   
    return [];
  }
};
